<template>
	<div class="">
		<pt-form-item label="类型" :labelWidth="labelWidth" :required="true">
      <detection-category-chinese-selector v-model="currentForm.type" name="type" v-validate="'required'" data-vv-as="类型"></detection-category-chinese-selector>
		</pt-form-item>
		<div v-if="checkType">
      <template v-if="hasSuggestionTypes.includes(currentForm.type) && hasSuggestionCorpuses.includes(corpusName)">
        <pt-sub-title title="疾病风险提示建议"></pt-sub-title>
        <pt-form-item label="高风险提示建议" :labelWidth="labelWidth">
          <el-input placeholder="请输入内容" v-model="currentForm.risk" type="textarea" :autosize="{ minRows: 5}"></el-input>
        </pt-form-item>
        <pt-form-item label="中风险提示建议" :labelWidth="labelWidth">
          <el-input placeholder="请输入内容" v-model="currentForm.concern" type="textarea" :autosize="{ minRows: 5}"></el-input>
        </pt-form-item>
        <pt-form-item label="低风险提示建议" :labelWidth="labelWidth">
          <el-input placeholder="请输入内容" v-model="currentForm.normal" type="textarea" :autosize="{ minRows: 5}"></el-input>
        </pt-form-item>
      </template>
			<component :is="detectionType" v-model="currentForm.contents" :type="currentForm.type"></component>
		</div>
	</div>
</template>

<script>
import detectionCategoryChineseSelector from 'cps/gene-product/selector/detection-category-chinese-selector'
import cancer from './cancer'
import { formatdetection } from 'enumeration/lab-order.js'
const hasSuggestionType = ['高危遗传病', '疾病', '罕见病']
const hasSuggestionCorpus = ['ASA儿童基因检测', 'PCR基因检测']
export default {
  props: {
    value: {
      type: Object,
      default: function () {
        return {}
      }
    },
    labelWidth: {
      type: String,
      default: '100px'
    },
    type: {
      type: String,
      default: ''
    },
    corpusName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentForm: JSON.stringify(this.value) !== '{}' ? this.value : {
        type: this.type,
        contents: []
      }
    }
  },
  watch: {
    currentForm: {
      handler: function (val, old) {
        this.$emit('input', val)
      },
      deep: true
    },
    type (val) {
      this.currentForm.type = val
    }
  },
  components: {
    cancer,
    detectionCategoryChineseSelector
  },
  computed: {
    checkType () {
      if (this.currentForm.type) {
        return true
      }
      return false
    },
    detectionType () {
      return 'cancer'
      // return this.formatdetection(this.currentForm.type)
    },
    hasSuggestionTypes () {
      return hasSuggestionType
    },
    hasSuggestionCorpuses () {
      return hasSuggestionCorpus
    }
  },
  methods: {
    formatdetection,
    reset () {
      this.currentForm = {}
    }
  }
}
</script>

<style lang="less">

</style>
